<app-navbar title="Ustawienie Strony - Szablony">
	<button class="me-4" mat-raised-button color="primary" routerLink="./add">
		<i class="fas fa-plus"></i>
		Dodaj
	</button>
</app-navbar>
<mat-table #dataTable [dataSource]="dataSource" matSortActive="id" matSort matSortDirection="asc">
	<ng-container matColumnDef="id">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Id </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.id }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="productKind">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Typ produktu </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.productKind.name }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="kind">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Typ </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.kind }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="edit">
		<mat-header-cell *matHeaderCellDef></mat-header-cell>
		<mat-cell *matCellDef="let element">
			<button mat-raised-button color="primary" routerLink="/www/descriptionTemplate/{{ element.id }}/">
				Edytuj
			</button>
		</mat-cell>
	</ng-container>
	<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
<div class="footer">
	<mat-paginator
		[pageSizeOptions]="[10, 20, 30]"
		[pageSize]="20"
		showFirstLastButtons
		aria-label="Select page of periodic elements"
	>
	</mat-paginator>
</div>
